export const useSocialMeta = ({
  title = "",
  description = "",
  url = "",
  type = "website",
  image = "",
}) => {
  const meta = [
    {
      key: "description",
      name: "description",
      content: description,
    },
    {
      key: "og:title",
      property: "og:title",
      content: title,
    },
    {
      key: "og:description",
      property: "og:description",
      content: description,
    },
    {
      key: "og:type",
      property: "og:type",
      content: type,
    },
    {
      key: "og:url",
      property: "og:url",
      content: url,
    },
    {
      key: "twitter:card",
      name: "twitter:card",
      content: image ? "summary_large_image" : "summary",
    },
    {
      key: "twitter:title",
      name: "twitter:title",
      content: title,
    },
    {
      key: "twitter:description",
      name: "twitter:description",
      content: description,
    },
  ];

  if (image) {
    meta.push(
      {
        key: "og:image",
        property: "og:image",
        content: image,
      },
      {
        key: "og:image:secure_url",
        property: "og:image:secure_url",
        content: image,
      },
      {
        key: "twitter:image",
        name: "twitter:image",
        content: image,
      }
    );
  }

  return meta;
};
